import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useAuth } from "../../contexts/AuthContext";

export default function AppShell() {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="h-screen w-full flex items-center justify-center">
                <div className="text-muted-foreground text-sm">Caricamento...</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return (
        <div className="flex min-h-screen bg-background">
            <Sidebar />
            <main className="flex-1 min-w-0">
                <Outlet />
            </main>
        </div>
    );
}
